enum GamReportRequest {
  Total = 'GAM_TOTAL',
  TotalsReach = 'GAM_TOTALS_REACH',
  Date = 'GAM_DATE',
  Device = 'GAM_DEVICE',
  Region = 'GAM_REGION',
  Channel = 'GAM_CHANNEL',
  Advertiser = 'GAM_ADVERTISER',
  Campaign = 'GAM_CAMPAIGN',
  Placement = 'GAM_PLACEMENT',
  Creative = 'GAM_CREATIVE',
  Deals = 'GAM_DEALS',
  GeoFence = 'GAM_GEO_FENCE',
  Publisher = 'GAM_PUBLISHER',
  Daypart = 'GAM_DAYPART',
  DayOfWeek = 'GAM_DAY_OF_WEEK',
  Dma = 'GAM_DMA',
  County = 'GAM_COUNTY',
  City = 'GAM_CITY',
  Zip = 'GAM_ZIP',
  CongressionalDistrict = 'GAM_CONGRESSIONAL_DISTRICT',
  StateBoundaries = 'GAM_STATE_BOUNDARIES',
  DmaBoundaries = 'GAM_DMA_BOUNDARIES',
  CountyBoundaries = 'GAM_COUNTY_BOUNDARIES',
  CityBoundaries = 'GAM_CITY_BOUNDARIES',
  ZipBoundaries = 'GAM_ZIP_BOUNDARIES',
  CongressionalDistrictBoundaries = 'GAM_CONGRESSIONAL_DISTRICT_BOUNDARIES',
}

export default GamReportRequest;
